<template>
    <a-modal
        v-model="visible"
        title=""
        width="750px"
        @cancel="$emit('update:visible', false)"
        :maskClosable="!loading"
        :footer="null"
    >
        <div class="mt-4" v-if="!showForm">
            <h4 class="font-weight-bolder text-left kova-text">Sprint Project</h4>
            <p class="text-left">
                Begin your sprint project exercise for
                <strong> Stage 2 </strong> vetting process
            </p>
            <h6 class="font-weight-bolder text-left">Instructions</h6>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col"><p class="text-left">Create a Gitlab account</p></div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        Open a private repond and name it
                        <strong> Kovatek Sprint Project </strong>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        Push code to private repo on your Gitlab accrual and Submit
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col-1 text-right">
                    <font-awesome-icon class="kova-text" style="font-size:10px" icon="circle"></font-awesome-icon>
                </div>
                <div class="col">
                    <p class="text-left">
                        Host on a fire testing server and submit link.
                    </p>
                </div>
            </div>
            <button @click="showForm = true" class="mt-3 ml-5 py-2 px-4 px-lg-5 font-weight-bolder request btn-kovatek">
                Create Sprint Exercise
            </button>
            <div v-if="deadline">
                <hr />
                <h6 class="font-weight-bolder text-left mt-3">Submission Deadline</h6>
                <p>
                    Your live interview exercise is on:
                    <span class="font-weight-bolder">{{ date | dateOnly }} at {{ time | timeOnly }}</span>
                </p>
            </div>
        </div>

        <div class="mt-4" v-else>
            <h4 class="font-weight-bolder text-left kova-text">{{ testName }}</h4>
            <p class="text-left">
                Choose the type and complexity of the exercise you want
            </p>

            <div class="row mx-auto">
                <!-- <div class="col-12">
          <h6 class="text-left">Category</h6>
          <a-select
            placeholder="Select"
            size="large"
            class="text-left w-75"
            v-model="test.category"
          >
            <a-select-option
              v-for="category in categories"
              :key="category"
              :value="category.toLowerCase()"
            >
              {{ category }}
            </a-select-option>
          </a-select>
          <p class="error my-0" v-if="error.includes('category')">{{ error }}</p>
        </div> -->

                <div class="col-12 mt-3">
                    <h6 class="text-left">Complexity</h6>
                    <a-select placeholder="Select" size="large" class="text-left w-75" v-model="test.complexity">
                        <a-select-option v-for="level in levels" :key="level.id" :value="level.id">
                            {{ level.level }}
                        </a-select-option>
                    </a-select>
                    <p class="error my-0" v-if="error.includes('complexity')">{{ error }}</p>
                </div>

                <div class="col-12 mt-3">
                    <h6 class="text-left">Skills</h6>
                    <a-select
                        placeholder="Select one or more"
                        size="large"
                        class="text-left w-75"
                        v-model="test.language"
                    >
                        <a-select-option v-for="skill in profile.skills" :key="skill" :value="skill">
                            {{ skill }}
                        </a-select-option>
                    </a-select>
                    <p class="error my-0" v-if="error.includes('skill')">{{ error }}</p>
                </div>

                <div class="col-12 mt-3">
                    <h6 class="text-left">Tags</h6>
                    <a-select
                        placeholder="Select one or more"
                        size="large"
                        class="text-left w-75"
                        v-model="test.testTags"
                        mode="multiple"
                    >
                        <a-select-option v-for="tag in specs" :key="tag" :value="tag">
                            {{ tag }}
                        </a-select-option>
                    </a-select>
                    <p class="error my-0" v-if="error.includes('tag')">{{ error }}</p>
                </div>

                <button
                    :loading="loading"
                    @click="acceptProject"
                    class="mt-3 ml-5 py-2 px-4 px-lg-5 font-weight-bolder request btn-kovatek"
                >
                    {{ loading ? 'Starting...' : 'Start' }}
                </button>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { categories } from '../../data/resources';
import specs from '../../data/specializations.json';

export default {
    props: {
        visible: Boolean,
        profile: Object,
    },
    data() {
        return {
            categories,
            loading: false,
            deadline: '',
            showForm: false,
            test: {
                complexity: this.profile.complexity,
            },
            error: '',
            specs,
        };
    },
    computed: {
        testName() {
            return `${this.test.language} Sprint Test`;
        },
    },
    methods: {
        acceptProject() {
            const { language, testTags, complexity } = this.test;

            let message = !complexity
                ? 'Please select the complexity of the test'
                : !testTags || !testTags.length
                ? 'Plese select at least one tag'
                : !language || !language.length
                ? 'Please select the skill for the test'
                : '';

            if (message.length) return (this.error = message);
            this.error = '';

            this.startExercise({
                name: this.testName,
                language,
                tags: testTags,
                complexity,
                category: this.profile.speciality,
                type: 2,
                instructions: '',
            });
        },
        async startExercise(data) {
            this.loading = true;
            const token = localStorage.getItem('token');
            try {
                const res = await this.$api({
                    url: `/tests`,
                    method: 'post',
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    data,
                });
                this.loading = false;
                this.$emit('done', res.data);
            } catch (err) {
                this.loading = false;
                this.catchErrors(err);
                // console.log(err)
            }
        },
    },
};
</script>
